// extracted by mini-css-extract-plugin
module.exports = {"banners":"PushkinCard_banners__3cnD7","socials":"PushkinCard_socials__1hV30","section":"PushkinCard_section__2tPCp"};